import VipRoom from './VipRoom'

export default VipRoom



// WEBPACK FOOTER //
// ./src/features/Hotel/components/VipRoom/index.js